<template>
  <div>
    <el-card>
      <z-search :configs="historyConfig" v-model="searchData" @do-query="query"></z-search>
    </el-card>
    <el-card class="mt10">
      <z-table
        v-loading="loading"
        :columns="historyColumns"
        :data="orderList"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
      >
        <template #qty="{ row }">
          <div style="position: relative" @click.stop>
            {{ row.qty }}
            <OrderGoods :row="row"></OrderGoods>
          </div>
        </template>
      </z-table>
    </el-card>
  </div>
</template>

<script>
import { historyColumns, getHistoryConfig } from '@/views/customer/config'
import { getCustomerHistoryList } from '@/server/etl'
import OrderGoods from './orderGoods'
import { getCustomerHistorySkuList } from '@/server/etl'
import { getShopList, getErpShopList } from '@/server/shopList'
import {
  ORDER_STATUS,
  SALES_STATUS,
  FULFILMENTSTATUS,
  PAY_TYPE,
  PAY_STATUS,
  PLATFORM,
  ORDER_STATUS_LIST,
} from '@/config'
export default {
  name: 'tab-history',
  components: { OrderGoods },
  data() {
    return {
      historyConfig: [],
      historyColumns,
      ORDER_STATUS,
      SALES_STATUS,
      FULFILMENTSTATUS,
      PAY_TYPE,
      PAY_STATUS,
      PLATFORM,
      ORDER_STATUS_LIST,
      searchData: {},
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      orderList: [],
      loading: false,
    }
  },
  computed: {
    merchantId() {
      return this.$store.state.user.merchantId
    },
    shopList() {
      return this.$store.state.products.shopList
    },
  },
  created() {
    this.getSearchConfig()
  },
  activated() {
    this.getList()
  },
  methods: {
    async getSearchConfig() {
      await this.$store.dispatch('getShopList')
      this.historyConfig = getHistoryConfig([...this.shopList])
    },
    query(params) {
      this.getList(params)
    },
    async getList(params = this.searchData) {
      this.loading = true
      const datas = {
        userEmail: this.$route.params.email,
        ...params,
        ...this.pagination,
        orgUnitId: this.merchantId,
      }
      delete datas.total
      const { data } = await getCustomerHistoryList({ ...datas })
      this.loading = false
      if (data.code === this.$code) {
        this.orderList = data.data.datas
        this.pagination.total = data.data.totalSize
      }
    },
    handlePageChange() {
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped></style>
